// var def = require('../Definitions.js');
var colors = require('../Colors.js');

// Export the tree

module.exports = {
  label: 'Material',
  properties: {
    cadspeed24: {
      label: 'CADSPEED24',
      tooltip: 'Versand noch am selben Tag bei Dateneingang bis 13 Uhr.',
      itemnum: 'CS482',
    },
    shiny: {
      label: 'Oberfläche glänzend',
      itemnum: 'CS492',
    },
  },
  children: {
    ZI: {
      maxunits: 16,
      label: 'Zirkon',
      properties: {
        color: colors(),
      },
      children: {
        mono: {
          label: 'Monochromes Zirkon',
          children: {
            ARGENZ: {
              label: 'ArgenZ HT+',
              itemnum: 'CS1067',
            },
            ZT: {
              label: 'Transluzent (Zt)',
              itemnum: 'CS402',
            },
          },
        },
        multi: {
          label: 'Mehrschichtig/Multilayer',
          children: {
            ArgenzHtMulti: {
              label: 'ArgenZ HT+ Multi',
              itemnum: 'CS1140',
              properties: {
                color: colors('A1', 'D4', ['0M1', '0M2', '0M3']),
              },
            },
            DDYHL: {
              label: 'Dental Direkt Y-HL',
              itemnum: 'CS2034',
              properties: {
                color: colors('A1', 'D4', ['0M1', '0M2', '0M3']),
              },
            },
            ZtM_Plus: {
              label: 'ZtM+',
              maxunits: 3,
              tooltip: 'multi hoch transluzentes Zirkon (ZtM+)',
              itemnum: 'CS404',
            },
            Katana_UTML: {
              maxunits: 3,
              label: 'Katana UTML',
              itemnum: 'CS536',
              properties: {
                cadspeed24: {
                  label: 'CADSPEED 24',
                  tooltip: 'Die Lieferzeit verkürzt sich um einen Tag.',
                  itemnum: 'CS482',
                },
              },
            },
            Katana_STML: {
              label: 'Katana STML',
              maxunits: 3,
              tooltip: 'Supertransluzentes Zirkon mit Farbverlauf (zur Schneide hin immer transluzenter).',
              itemnum: 'CS405',
              properties: {
                color: colors('A1', 'B3', ['C1', 'C2', 'C3', 'D2', 'D3']),
              },
            },
            Katana_YML: {
              label: 'Katana Y-ML',
              itemnum: 'CS2082',
              properties: {
                color: colors('A1', 'B3', ['C1', 'C2', 'C3', 'D2', 'D3']),
              },
            },
          },
        },
      },
    },
    metal: {
      label: 'Metall',
      children: {
        coro: {
          label: 'CoCr',
          key: 'material',
          children: {
            NEM: {
              maxunits: 16,
              label: 'Kronen & Brücken, gefräst',
              itemnum: 'CS406',
              properties: {
                retention: {
                  flat: true,
                  label: 'Retention pauschal',
                  tooltip: 'Pauschale pro Kiefer bei Retentionen größer als eine Zahnbreite.',
                  itemnum: 'CS502',
                },
              },
            },
            LSNEM: {
              maxunits: 16,
              label: 'Kronen & Brücken, gelasert',
              itemnum: 'CS407',
              properties: {
                retention: {
                  flat: true,
                  label: 'Retention pauschal',
                  tooltip: 'Pauschale pro Kiefer bei Retentionen größer als eine Zahnbreite.',
                  itemnum: 'CS502',
                },
                cadspeed24: null,
              },
            },
            NEM_PreFace: {
              label: 'Abutment, einteilig',
              itemnum: 'CS411',
              requireAttachments: [
                {
                  OR: ['constructionInfo', '/ImplantDirectionPosition(_[0-9]+)?.xml$/'],
                  message: 'Es muss eine Datei vom Type .constructionInfo oder ImplantDirectionPosition.xml hochgeladen werden!',
                },
              ],
              properties: {
                adhesive: null,
                tibase: null,
                design: null,
                abutmentoriginal: {
                  label: 'Materialzuschlag Original-Abutment',
                  required: true,
                  type: 'select',
                  defaultValue: null,
                  options: [
                    {
                      value: 'original',
                      label: 'Original',
                      itemnum: 'CS1859',
                    },
                    {
                      value: 'generic',
                      label: 'Normal (Generika)',
                    },
                  ],
                },
              },
            },
            LSNEM_MoGu: {
              label: 'Modellguss, gelasert',
              itemnum: 'CS412',
              properties: {
                entirejaw: {
                  type: 'hidden',
                  value: 1,
                },
                cadspeed24: null,
                cadspeed24mogu: {
                  label: 'CADSPEED 24',
                  tooltip: 'Die Lieferzeit verkürzt sich um einen Tag.',
                  itemnum: 'CS487',
                },
                shiny: {
                  label: 'Oberfläche glänzend',
                  itemnum: 'CS484',
                },
                adhesive: null,
                tibase: null,
              },
            },
            Frame_Laser: {
              label: 'Tertiärgerüst, gelasert',
              itemnum: 'CS534',
              properties: {
                cadspeed24: null,
              },
            },
          },
        },
        ti: {
          label: 'Titan',
          key: 'material',
          children: {
            TI: {
              maxunits: 16,
              label: 'Kronen & Brücken, gefräst',
              itemnum: 'CS441',
              properties: {
                retention: {
                  flat: true,
                  label: 'Retention pauschal',
                  tooltip: 'Pauschale pro Kiefer bei Retentionen größer als eine Zahnbreite.',
                  itemnum: 'CS502',
                },
              },
            },
            TI_PreFace: {
              label: 'Abutment, einteilig',
              itemnum: 'CS442',
              requireAttachments: [
                {
                  OR: ['constructionInfo', '/ImplantDirectionPosition(_[0-9]+)?.xml$/'],
                  message: 'Es muss eine Datei vom Type .constructionInfo oder ImplantDirectionPosition.xml hochgeladen werden!',
                },
              ],
              properties: {
                design: null,
                abutmentoriginal: {
                  label: 'Materialzuschlag Original-Abutment',
                  required: true,
                  type: 'select',
                  defaultValue: null,
                  options: [
                    {
                      value: 'original',
                      label: 'Original',
                      itemnum: 'CS1859',
                    },
                    {
                      value: 'generic',
                      label: 'Normal (Generika)',
                    },
                  ],
                },
              },
            },
            TI_MoGu: {
              label: 'Modellguss, gelasert',
              itemnum: 'CS443',
              properties: {
                entirejaw: {
                  type: 'hidden',
                  value: 1,
                },
                shiny: {
                  label: 'Oberfläche glänzend',
                  itemnum: 'CS484',
                },
                adhesive: null,
                tibase: null,
                cadspeed24: null,
              },
            },
          },
        },
      },
    },
    ks: {
      label: 'Kunststoff',
      children: {
        Modell_3D: {
          label: 'Modell, gedruckt',
          properties: {
            adhesive: null,
            tibase: null,
            color: null,
            entirejaw: {
              type: 'hidden',
              value: 1,
            },
          },
          children: {
            Quadrant_3D: {
              label: 'Kiefermodell, Quadrant',
              itemnum: 'CS462',
              properties: {},
            },
            Ganzkiefermodell_3D: {
              label: 'Ganzkiefermodell',
              itemnum: 'CS463',
              properties: {
                socket: {
                  label: 'Mit Sockel',
                  itemnum: 'CS464',
                },
              },
            },
            Stubs: {
              maxunits: 16,
              label: 'Herausnehmbare Stümpfe',
              itemnum: 'CS465',
              properties: {
                cadspeed24: null,
              },
            },
            Gingiva_Mask: {
              maxunits: 16,
              label: 'Zahnfleischmaske',
              itemnum: 'CS519',
              properties: {},
            },
            Ganzkiefermodell_Filament: {
              label: 'Ganzkiefermodell Filament',
              itemnum: 'CS1945',
              properties: {},
            },
            Quadrant_Filament: {
              label: 'Kiefermodell Quadrant Filament',
              itemnum: 'CS1946',
              properties: {},
            },
          },
        },
        PMMA: {
          maxunits: 16,
          label: 'PMMA',
          itemnum: 'CS452',
          properties: {
            color: colors('A1', 'C4', ['D2', 'D3', 'D4', 'Klar', 'Rosa']),
          },
        },
        PMMA_Multi: {
          maxunits: 16,
          label: 'PMMA Multilayer',
          itemnum: 'CS453',
          properties: {
            color: colors(['A2', 'A3', 'A3,5']),
          },
        },
        pk: {
          label: 'PEEK',
          children: {
            PEEK: {
              maxunits: 16,
              label: 'PEEK',
              itemnum: 'CS454',
              properties: {
                color: colors(['Weiß', 'Juvora', 'A3', 'Rosa']),
              },
            },
            PEEK_MoGu: {
              label: 'PEEK Modellguss ',
              itemnum: 'CS455',
              properties: {
                entirejaw: {
                  type: 'hidden',
                  value: 1,
                },
                cadspeed24: null,
                cadspeed24mogu: {
                  label: 'CADSPEED 24',
                  tooltip: 'Die Lieferzeit verkürzt sich um einen Tag.',
                  itemnum: 'CS487',
                },
                shiny: {
                  label: 'Oberfläche glänzend',
                  itemnum: 'CS484',
                },
                color: colors(['Weiß', 'Juvora', 'A3', 'Rosa']),
              },
            },
            PEEK_MoGu_In: {
              label: 'PEEK Modellguss, innenliegend',
              itemnum: 'CS456',
              properties: {
                entirejaw: {
                  type: 'hidden',
                  value: 1,
                },
                cadspeed24: null,
                cadspeed24mogu: {
                  label: 'CADSPEED 24',
                  tooltip: 'Die Lieferzeit verkürzt sich um einen Tag.',
                  itemnum: 'CS487',
                },
                shiny: {
                  label: 'Oberfläche glänzend',
                  itemnum: 'CS484',
                },
                color: colors(['Weiß', 'Juvora', 'A3', 'Rosa']),
              },
            },
          },
        },
        sf: {
          label: 'Schiene gefräst',
          children: {
            PMMA_Schiene: {
              label: 'Schiene PMMA',
              itemnum: 'CS458',
              properties: {
                cadspeed24: {
                  label: 'CADSPEED 24',
                  tooltip: 'Versand noch am selben Tag bei Dateneingang bis 13 Uhr.',
                  itemnum: 'CS486',
                },
                shiny: {
                  label: 'Oberfläche glänzend',
                  itemnum: 'CS501',
                },
                color: colors('A1', 'D4', ['Pink', 'Klar'], null, 'Klar'),
                adhesive: null,
                tibase: null,
              },
            },
            PC_Schiene: {
              label: 'Schiene Polycarbonat',
              itemnum: 'CS459',
              properties: {
                cadspeed24: {
                  label: 'CADSPEED 24',
                  tooltip: 'Versand noch am selben Tag bei Dateneingang bis 13 Uhr.',
                  itemnum: 'CS486',
                },
                shiny: {
                  label: 'Oberfläche glänzend',
                  itemnum: 'CS501',
                },
                color: colors('A1', 'A2', ['Klar'], null, 'Klar'),
                adhesive: null,
                tibase: null,
              },
            },
            PC_Schiene_Zahnfarbend: {
              label: 'Schiene Polycarbonat Zahnfarbe',
              itemnum: 'CS957',
              properties: {
                color: colors(['A1', 'A2']),
              },
            },
            Clearsplint: {
              label: 'Clearsplint',
              itemnum: 'CS989',
              properties: {
                cadspeed24: {
                  label: 'CADSPEED 24',
                  tooltip: 'Versand noch am selben Tag bei Dateneingang bis 13 Uhr.',
                  itemnum: 'CS486',
                },
                adhesive: null,
                tibase: null,
                color: null,
              },
            },
            DDBio: {
              label: 'Thermoplastische DD Bio Splint FLEX',
              itemnum: 'CS2042',
              properties: {
                cadspeed24: {
                  label: 'CADSPEED 24',
                  tooltip: 'Versand noch am selben Tag bei Dateneingang bis 13 Uhr.',
                  itemnum: 'CS486',
                },
                adhesive: null,
                tibase: null,
                color: null,
              },
            },
            Memosplint: {
              label: 'Memosplint',
              itemnum: 'CS1146',
              properties: {
                cadspeed24: {
                  label: 'CADSPEED 24',
                  tooltip: 'Versand noch am selben Tag bei Dateneingang bis 13 Uhr.',
                  itemnum: 'CS486',
                },
                adhesive: null,
                tibase: null,
                color: null,
              },
            },
          },
        },
        sd: {
          label: 'Schiene gedruckt',
          children: {
            Schiene_3D: {
              label: 'Schiene',
              properties: {
                cadspeed24: null,
                shiny: {
                  label: 'Oberfläche glänzend',
                  itemnum: 'CS501',
                },
                material: {
                  label: 'Material',
                  required: true,
                  type: 'select',
                  defaultValue: 'CS460',
                  options: [
                    {
                      itemnum: 'CS460',
                      value: 'CS460',
                      label: 'E-Guard',
                    },
                    {
                      itemnum: 'CS1080',
                      value: 'CS1080',
                      label: 'Smile Guard (Thermoplastisch flexibel)',
                    },
                  ],
                },
                adhesive: null,
                tibase: null,
                color: null,
              },
            },
            Splint_3D: {
              label: 'Splint / Bohrschablone',
              itemnum: 'CS461',
              properties: {
                adhesive: null,
                tibase: null,
                color: null,
              },
            },
            /*Keysplint_3D: {
              label: 'Keysplint',
              itemnum: 'CS1935',
              properties: {
                cadspeed24: null,
                adhesive: null,
                tibase: null,
                color: null,
              },
            },*/
          },
        },
        BioHPP: {
          maxunits: 16,
          label: 'BioHPP',
          itemnum: 'CS555',
          properties: {
            cadspeed24: {
              label: 'CADSPEED 24',
              tooltip: 'Versand noch am selben Tag bei Dateneingang bis 13 Uhr.',
              itemnum: 'CS486',
            },
            color: colors(['Weiß', 'Dentin-Shade 2']),
          },
        },
        eldy: {
          label: 'ELDY',
          children: {
            Eldy: {
              label: 'Prothesenbasis (Grundeinheit)',
              itemnum: 'CS1075',
              properties: {
                color: colors(['Klar', 'Rosa', 'A1', 'A2', 'A3', 'A3,5']),
              },
            },
            Eldy_Zahnfarbend: {
              label: 'Prothesenbasis Zahnfarbe (Grundeinheit)',
              itemnum: 'CS1099',
              properties: {
                color: colors(['A1', 'A2', 'Multi A2/A3']),
              },
            },
            Eldy_Zahnfarbend_milled: {
              label: 'Einheit Zahnfarbe',
              itemnum: 'CS1071',
              properties: {
                cadspeed24: {
                  label: 'CADSPEED 24',
                  tooltip: 'Versand noch am selben Tag bei Dateneingang bis 13 Uhr.',
                  itemnum: 'CS482',
                },
                color: colors(['A1', 'A2', 'A3', 'A3,5', 'Multi A2/A3']),
              },
            },
            Eldy_Schiene_Klar: {
              label: 'Schiene Klar',
              itemnum: 'CS1100',
              maxunits: 1,
              properties: {
                cadspeed24: {
                  label: 'CADSPEED 24',
                  tooltip: 'Versand noch am selben Tag bei Dateneingang bis 13 Uhr.',
                  itemnum: 'CS486',
                },
                color: colors(['A1', 'A2', 'A3', 'A3,5', 'Klar']),
              },
            },
          },
        },
        Loeffel_3D: {
          label: 'Funktionslöffel, gedruckt',
          itemnum: 'CS529',
        },
        Bohr_3D: {
          label: 'Bohrschablone, gedruckt',
          itemnum: 'CS495',
          properties: {
            cadspeed24: null,
          },
        },
      },
    },
    glas: {
      maxunits: 3,
      label: 'Glaskeramik',
      children: {
        emax_LT: {
          label: 'e.max LT',
          maxunits: 3,
          itemnum: 'CS466',
          properties: {
            color: colors('A1', 'D4', ['BL1', 'BL2', 'BL3', 'BL4']),
          },
        },
        emax_MT: {
          label: 'e.max MT',
          maxunits: 3,
          itemnum: 'CS467',
          properties: {
            color: colors(['A1', 'A2', 'A3', 'B1', 'BL2', 'BL3', 'BL4']),
          },
        },
        emax_HT: {
          label: 'e.max HT',
          maxunits: 3,
          itemnum: 'CS468',
          properties: {
            color: colors('A1', 'D4', ['BL1', 'BL2', 'BL3', 'BL4']),
          },
        },
        emax: {
          label: 'e.max Sonstiges',
          maxunits: 3,
          itemnum: 'CS469',
          properties: {
            color: colors(['MO0', 'MO1', 'MO2', 'MO3', 'MO4', 'HT BL1', 'HT BL2', 'HT BL3', 'HT BL4', 'LT BL1', 'LT BL2', 'LT BL3', 'LT BL4', 'MT BL2', 'MT BL3', 'MT BL4']),
          },
        },
        Empress_LT: {
          label: 'Empress LT',
          itemnum: 'CS470',
          properties: {
            color: colors(['A1', 'A2', 'A3', 'A3,5', 'B1', 'B2', 'B3', 'C2', 'D3', 'BL1', 'BL2', 'BL3', 'BL4']),
          },
        },
        Empress_HT: {
          label: 'Empress HT',
          itemnum: 'CS471',
          properties: {
            color: colors(['A1', 'A2', 'A3', 'A3,5', 'B1', 'B2', 'B3', 'C2', 'D3']),
          },
        },
        Empress_Multi: {
          label: 'Empress Multi',
          itemnum: 'CS472',
          properties: {
            color: colors(['A1', 'A2', 'A3', 'A3,5', 'B1', 'BL1', 'BL3']),
          },
        },
        Celtra_LT: {
          label: 'Celtra Duo LT',
          itemnum: 'CS473',
          properties: {
            color: colors(['A1', 'A2', 'A3', 'A3,5', 'B1', 'B2', 'C1', 'C2', 'D2', 'D3', 'BL2', 'BL3']),
          },
        },
        Celtra_HT: {
          label: 'Celtra Duo HT',
          itemnum: 'CS474',
          properties: {
            color: colors(['A1', 'A2', 'A3', 'B1', 'C1', 'C2', 'D2', 'D3']),
          },
        },
        Suprinity_T: {
          label: 'VITA Suprinity T',
          itemnum: 'CS475',
          properties: {
            color: colors(['0M1', '1M1', '1M2', '2M2', '3M2', '4M2', 'A1', 'A2', 'A3', 'A3,5', 'B2', 'C2', 'D2']),
          },
        },
        Suprinity_HT: {
          label: 'VITA Suprinity HT',
          itemnum: 'CS476',
          properties: {
            color: colors(['0M1', '1M1', '1M2', '2M2', '3M2', '4M2', 'A1', 'A2', 'A3', 'A3,5', 'B2', 'C2', 'D2']),
          },
        },
        TriLuxe: {
          label: 'TriLuxe Forte',
          itemnum: 'CS477',
          properties: {
            color: colors(['A1', 'A2', 'A3', 'A3,5', '0M1', '1M1', '1M2', '2M2', '3M2']),
          },
        },
        Mark_II: {
          label: 'Vita Mark II',
          itemnum: 'CS478',
          properties: {
            color: colors(['A1', 'A2', 'A3', 'A3,5', 'A4', 'B2', 'B3', 'C2', 'C3', 'D3', '1M1', '1M2', '2M1', '2M2', '2M3', '3M1', '3M2', '3M3', '4M2']),
          },
        },
      },
    },
    composite: {
      maxunits: 16,
      label: 'Komposite',
      children: {
        Ambarino: {
          label: 'Ambarino High-Class',
          itemnum: 'CS479',
          properties: {
            color: colors(['A2', 'A3', 'B1', 'C2', 'D2']),
          },
        },
        Ultimate_LT: {
          label: 'Lava Ultimate LT',
          itemnum: 'CS480',
          properties: {
            color: colors(['A1', 'A2', 'A3', 'A3,5', 'B1', 'C2', 'D2']),
          },
        },
        Ultimate_HT: {
          label: 'Lava Ultimate HT',
          itemnum: 'CS499',
          properties: {
            color: colors(['A1', 'A2', 'A3', 'B1']),
          },
        },
        Enamic_T: {
          label: 'VITA Enamic T',
          itemnum: 'CS481',
          properties: {
            color: colors(['0M1', '1M1', '1M2', '2M2', '3M2', '4M2']),
          },
        },
        Enamic_HT: {
          label: 'VITA Enamic HT',
          itemnum: 'CS500',
          properties: {
            color: colors(['0M1', '1M1', '1M2', '2M2', '3M2', '4M2']),
          },
        },
      },
    },
    EM: {
      label: 'Edelmetall und Wachs',
      key: 'material',
      properties: {
        shiny: null,
      },
      children: {
        WAX: {
          label: 'Wachs',
          itemnum: 'CS489',
        },
        HGHAL: {
          label: 'Hochgoldhaltige Aufbrennlegierung',
          children: {
            Gold_ArgentYellow: {
              label: 'Argedent Bio Yellow PF',
              itemnum: 'CS872',
            },
            Gold_Argent: {
              label: 'Argedent BIO 720 PF',
              itemnum: 'CS451',
            },
          },
        },
        MILAG: {
          label: 'Multiindikative Legierung auf Goldbasis',
          children: {
            Gold_Arginorm: {
              label: 'Arginorm',
              itemnum: 'CS2025',
            },
            Gold_Argistarsafe: {
              label: 'Argistar 38/ Argisafe 38',
              itemnum: 'CS446',
            },
          },
        },
        MILAS: {
          label: 'Multiindikative Legierung auf Silberbasis',
          children: {
            Silber_Argistarsafe: {
              label: 'Argistar 40/ Argisafe 40',
              itemnum: 'CS447',
            },
          },
        },
        /*HGHGL: {
          label: 'Hochgoldhaltige Gusslegierung',
          children: {
            Gold_Argenco: {
              label: 'Argenco Bio 2',
              itemnum: 'CS539',
            },
          },
        },*/
      },
    },
  },
}
